import pagination from '@/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('tourCruises');

const actions = {
    requestFetchTourCruises: baseActions.request,
    fetchTourCruisesSucceeded: baseActions.succeeded,
    fetchTourCruisesFailed: baseActions.failed,
};

export { types, actions };

export default reducer;
